import { useEffect, useRef, useState } from 'react';

/** Abre e fecha um menu suspenso; fecha com Esc ou com clique fora dele. */
export function useMenuSuspenso() {
  const [aberto, definirAberto] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!aberto) return;
    const aoAgir = (evento: Event) => {
      const fora = evento instanceof KeyboardEvent ? evento.key === 'Escape' : !ref.current?.contains(evento.target as Node);
      if (fora) definirAberto(false);
    };
    document.addEventListener('pointerdown', aoAgir);
    document.addEventListener('keydown', aoAgir);
    return () => {
      document.removeEventListener('pointerdown', aoAgir);
      document.removeEventListener('keydown', aoAgir);
    };
  }, [aberto]);

  return { aberto, ref, alternar: () => definirAberto(!aberto), fechar: () => definirAberto(false) };
}
